"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCallbackSendFunction = exports.sendClient = exports.sendSession = exports.sendEvent = void 0;
require("isomorphic-fetch");
const get_base_url_1 = __importDefault(require("./get-base-url"));
const types_1 = require("../types");
const shorten_look_ups_1 = __importDefault(require("./shorten-look-ups"));
const headers = {
    'Content-Type': 'text/plain;charset=UTF-8',
};
const sendData = (url, data) => {
    const shouldRespond = !!data.expectsResponse;
    if (shouldRespond) {
        delete data.expectsResponse;
        const jsonData = JSON.stringify(shorten_look_ups_1.default(data));
        return fetch(url, {
            method: 'POST',
            headers,
            body: jsonData,
        }).then((res) => res.json());
    }
    const jsonData = JSON.stringify(shorten_look_ups_1.default(data));
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        return navigator.sendBeacon(url, jsonData) ? Promise.resolve() : Promise.reject();
    }
    return fetch(url, {
        method: 'POST',
        headers,
        body: jsonData,
    }).then((res) => (res.status === 200 ? Promise.resolve() : Promise.reject()));
};
exports.sendEvent = (event) => {
    return sendData(`${get_base_url_1.default(event.dataResidency)}/event`, event);
};
exports.sendSession = (session) => {
    return sendData(`${get_base_url_1.default(session.dataResidency)}/session`, session);
};
exports.sendClient = (client) => {
    return sendData(`${get_base_url_1.default(client.dataResidency)}/client`, client);
};
exports.getCallbackSendFunction = (requestType) => {
    switch (requestType) {
        case types_1.DataRequestTypeEnum.SESSION:
            return exports.sendSession;
        case types_1.DataRequestTypeEnum.EVENT:
            return exports.sendEvent;
        case types_1.DataRequestTypeEnum.CLIENT:
            return exports.sendClient;
        default:
            return null;
    }
};
